import { render, staticRenderFns } from "./TransportationForm.vue?vue&type=template&id=08508866"
import script from "./TransportationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransportationForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports